import sortBy from 'lodash-es/sortBy'

export function sortParticipantsMoreItems(items) {
  return sortBy(items, ['user.fullname'])
}
